export const ROBOT_GET_ROUTINE_HISTORY_TIME_REQUEST = 'ROBOT_GET_ROUTINE_HISTORY_TIME_REQUEST';
export const ROBOT_GET_ROUTINE_HISTORY_TIME_SUCCESS = 'ROBOT_GET_ROUTINE_HISTORY_TIME_SUCCESS';
export const ROBOT_GET_ROUTINE_HISTORY_TIME_FAILURE = 'ROBOT_GET_ROUTINE_HISTORY_TIME_FAILURE';
export const ROUTINE_SELECTED_HISTORY_TIME = 'ROUTINE_SELECTED_HISTORY_TIME';
export const ROBOT_GET_ROUTINE_HISTORY_PAGE_REQUEST = 'ROBOT_GET_ROUTINE_HISTORY_PAGE_REQUEST'
export const ROBOT_GET_ROUTINE_HISTORY_PAGE_SUCCESS = 'ROBOT_GET_ROUTINE_HISTORY_PAGE_SUCCESS'
export const ROBOT_GET_ROUTINE_HISTORY_PAGE_FAILURE = 'ROBOT_GET_ROUTINE_HISTORY_PAGE_FAILURE'
export const SET_ROUTINE_HISTORY_FILTER = 'SET_ROUTINE_HISTORY_FILTER';
export const SET_PAGE_LIMIT = 'SET_PAGE_LIMIT'